import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div style={{ padding: '40px 20px', maxWidth: '900px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.8', color: '#333' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#2a2a2a' }}>Informativa sulla Privacy</h1>
      <p style={{ marginBottom: '30px', color: '#666' }}>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>1. Introduzione</h2>
        <p>Benvenuti in Haridem Photography Studio. La presente Informativa sulla Privacy descrive come raccogliamo, utilizziamo, conserviamo e proteggiamo le vostre informazioni personali quando utilizzate il nostro sito web e i nostri servizi fotografici professionali.</p>
        <p>Ci impegniamo a proteggere la vostra privacy e a garantire la sicurezza dei vostri dati personali in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) e le leggi italiane sulla privacy.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>2. Titolare del Trattamento</h2>
        <p><strong>Haridem Photography Studio</strong></p>
        <p>Email: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a></p>
        <p>Telefono: +39 XXX XXX XXXX</p>
        <p>Indirizzo: [Inserire indirizzo completo]</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>3. Dati Raccolti</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>3.1 Dati Forniti Volontariamente</h3>
        <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Numero di telefono</li>
          <li>Indirizzo di fatturazione e spedizione</li>
          <li>Informazioni di pagamento (elaborate tramite processori di pagamento sicuri)</li>
          <li>Preferenze fotografiche e dettagli del servizio richiesto</li>
          <li>Messaggi inviati tramite modulo di contatto</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>3.2 Dati Raccolti Automaticamente</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Indirizzo IP</li>
          <li>Tipo di browser e dispositivo</li>
          <li>Pagine visitate e durata della visita</li>
          <li>Sistema operativo</li>
          <li>Referrer URL</li>
          <li>Cookie e tecnologie di tracciamento simili</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>4. Finalità del Trattamento</h2>
        <p>Utilizziamo i vostri dati personali per:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Fornire i servizi fotografici richiesti</li>
          <li>Processare ordini e pagamenti</li>
          <li>Comunicare con voi riguardo ai vostri ordini e servizi</li>
          <li>Inviare newsletter e comunicazioni promozionali (solo con consenso)</li>
          <li>Migliorare il nostro sito web e i nostri servizi</li>
          <li>Analizzare le tendenze e le preferenze degli utenti</li>
          <li>Prevenire frodi e garantire la sicurezza</li>
          <li>Adempiere agli obblighi legali e fiscali</li>
          <li>Gestire richieste di supporto clienti</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>5. Base Giuridica del Trattamento</h2>
        <p>Trattiamo i vostri dati personali sulla base di:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>Esecuzione del contratto:</strong> per fornire i servizi richiesti</li>
          <li><strong>Consenso:</strong> per comunicazioni di marketing e cookie non essenziali</li>
          <li><strong>Legittimo interesse:</strong> per migliorare i servizi e prevenire frodi</li>
          <li><strong>Obbligo legale:</strong> per adempiere a requisiti fiscali e legali</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>6. Condivisione dei Dati</h2>
        <p>I vostri dati personali possono essere condivisi con:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>Fornitori di servizi:</strong> processori di pagamento, servizi di hosting, servizi di email marketing</li>
          <li><strong>Partner logistici:</strong> per la spedizione di attrezzatura fotografica</li>
          <li><strong>Professionisti:</strong> consulenti legali, fiscali e contabili</li>
          <li><strong>Autorità:</strong> quando richiesto dalla legge</li>
        </ul>
        <p>Tutti i fornitori terzi sono soggetti a rigorosi accordi di protezione dei dati e trattano i vostri dati solo secondo le nostre istruzioni.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>7. Cookie e Tecnologie di Tracciamento</h2>
        <p>Utilizziamo cookie e tecnologie simili per:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>Cookie essenziali:</strong> necessari per il funzionamento del sito</li>
          <li><strong>Cookie analitici:</strong> Google Analytics per comprendere l'utilizzo del sito</li>
          <li><strong>Cookie di marketing:</strong> Facebook Pixel e Google Ads per pubblicità mirata</li>
          <li><strong>Cookie di preferenze:</strong> per ricordare le vostre scelte</li>
        </ul>
        <p>Potete gestire le preferenze sui cookie attraverso le impostazioni del browser o il nostro banner cookie.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>8. Conservazione dei Dati</h2>
        <p>Conserviamo i vostri dati personali per il tempo necessario a:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Fornire i servizi richiesti</li>
          <li>Adempiere agli obblighi legali (10 anni per dati fiscali)</li>
          <li>Risolvere controversie e far rispettare accordi</li>
        </ul>
        <p>I dati di marketing sono conservati fino alla revoca del consenso. I dati dell'account possono essere cancellati su richiesta.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>9. I Vostri Diritti</h2>
        <p>Ai sensi del GDPR, avete diritto a:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>Accesso:</strong> ottenere conferma del trattamento e copia dei dati</li>
          <li><strong>Rettifica:</strong> correggere dati inesatti o incompleti</li>
          <li><strong>Cancellazione:</strong> richiedere la cancellazione dei dati</li>
          <li><strong>Limitazione:</strong> limitare il trattamento in determinate circostanze</li>
          <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato</li>
          <li><strong>Opposizione:</strong> opporsi al trattamento per motivi legittimi</li>
          <li><strong>Revoca del consenso:</strong> revocare il consenso in qualsiasi momento</li>
          <li><strong>Reclamo:</strong> presentare reclamo al Garante per la Protezione dei Dati Personali</li>
        </ul>
        <p>Per esercitare i vostri diritti, contattateci a: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a></p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>10. Sicurezza dei Dati</h2>
        <p>Implementiamo misure di sicurezza tecniche e organizzative appropriate, tra cui:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Crittografia SSL/TLS per le trasmissioni di dati</li>
          <li>Crittografia dei dati sensibili memorizzati</li>
          <li>Controlli di accesso e autenticazione</li>
          <li>Firewall e sistemi di rilevamento intrusioni</li>
          <li>Backup regolari dei dati</li>
          <li>Formazione del personale sulla protezione dei dati</li>
          <li>Valutazioni periodiche dei rischi di sicurezza</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>11. Trasferimenti Internazionali</h2>
        <p>Alcuni dei nostri fornitori di servizi potrebbero trovarsi al di fuori dello Spazio Economico Europeo (SEE). In tali casi, garantiamo che siano in atto adeguate garanzie, come:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Clausole contrattuali standard approvate dalla Commissione Europea</li>
          <li>Decisioni di adeguatezza della Commissione Europea</li>
          <li>Certificazione Privacy Shield (dove applicabile)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>12. Minori</h2>
        <p>I nostri servizi non sono destinati a persone di età inferiore a 18 anni. Non raccogliamo consapevolmente dati personali da minori. Se veniamo a conoscenza di aver raccolto dati da un minore senza il consenso dei genitori, cancelleremo tali informazioni tempestivamente.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>13. Fotografie e Immagini</h2>
        <p>Le fotografie scattate durante i nostri servizi fotografici rimangono di vostra proprietà. Chiediamo un consenso separato per utilizzare le immagini a scopo promozionale nella nostra galleria o sui social media. Potete revocare tale consenso in qualsiasi momento.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>14. Modifiche all'Informativa</h2>
        <p>Potremmo aggiornare periodicamente questa Informativa sulla Privacy. Vi notificheremo eventuali modifiche sostanziali tramite email o avviso sul sito web. La data dell'ultimo aggiornamento è indicata in cima a questa pagina.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>15. Contatti</h2>
        <p>Per domande, dubbi o richieste relative alla privacy, potete contattarci:</p>
        <ul style={{ listStyle: 'none', marginLeft: '0' }}>
          <li><strong>Email:</strong> <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a></li>
          <li><strong>Telefono:</strong> +39 XXX XXX XXXX</li>
          <li><strong>Indirizzo:</strong> Haridem Photography Studio, [Indirizzo completo]</li>
        </ul>
        <p style={{ marginTop: '20px' }}><strong>Autorità di Controllo:</strong></p>
        <p>Garante per la Protezione dei Dati Personali<br />
        Piazza Venezia, 11 - 00187 Roma<br />
        Tel: +39 06 696771<br />
        Email: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a><br />
        Web: www.garanteprivacy.it</p>
      </section>

      <div style={{ marginTop: '50px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
        <p style={{ margin: '0', fontSize: '0.9rem', color: '#666' }}>
          Questa Informativa sulla Privacy è parte integrante dei Termini e Condizioni di Haridem Photography Studio. 
          Utilizzando il nostro sito web e i nostri servizi, accettate le pratiche descritte in questa informativa.
        </p>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;